module.exports = __webpack_public_path__ + "static/media/LB.ed7ed52d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/LB.svg
// module id = 2194
// module chunks = 7